import { Cancel, Delete, Edit, PostAdd, Save } from '@mui/icons-material';
import { MenuItem, Popover, CircularProgress, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const GeneratedPostPendingApprovalGridActionPopup = ({
    popoverElement,
    approvePostDetails,
    handleCloseMenu,
    saveAsDraft,
    editPost,
    editAsNewPost,
    deletePost,
    loading,
    handlePreview
}) => {
    const { t: translate } = useTranslation();
    return (
        <Popover
            open={Boolean(popoverElement)}
            anchorEl={popoverElement}
            onClose={handleCloseMenu}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
                sx: { p: 1, width: 170, '& .MuiMenuItem-root': { px: 1, typography: 'body2', borderRadius: 0.75 } },
            }}
        >
            {' '} {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                    <CircularProgress size={24} />
                </Box>
            ) :
                <>
                    {/* Removed Preview from the popover menu in list view */}
                    {approvePostDetails.has_edit_access && <MenuItem sx={{ color: 'info.main' }} onClick={editPost}>
                        <Edit sx={{ mr: 1, color: 'info.main' }} /> {translate('generated_post_pending_approval_grid_action_popup.edit_post', 'Edit Post')}
                    </MenuItem>}
                    <MenuItem sx={{ color: 'info.main' }} onClick={editAsNewPost}>
                        <PostAdd sx={{ mr: 1, color: 'info.main' }} /> {translate('generated_post_pending_approval_grid_action_popup.edit_as_new_post', 'Edit As New Post')}
                    </MenuItem>
                    <MenuItem sx={{ color: 'warning.main' }} onClick={saveAsDraft}>
                        <Save sx={{ mr: 1, color: 'warning.main' }} /> {translate('generated_post_pending_approval_grid_action_popup.save_as_draft', 'Save As Draft')}
                    </MenuItem>
                    {approvePostDetails.has_delete_access && <MenuItem sx={{ color: 'error.main' }} onClick={deletePost}>
                        <Delete sx={{ mr: 1, color: 'error.main' }} /> {translate('generated_post_pending_approval_grid_action_popup.delete_post', 'Delete Post')}
                    </MenuItem>}
                </>}

        </Popover>
    );
};
export default GeneratedPostPendingApprovalGridActionPopup;
